// Mapbox configuration
const DEFAULT_MAPBOX_TOKEN = 'pk.eyJ1IjoicGlja3VwaHVuZ2FyeSIsImEiOiJjbTk3bXRmMDUwMHA0MmxzY2Q3cXF1cnl0In0.Nz167gOtZMHnAd0gCg-mJw';

export const MAPBOX_ACCESS_TOKEN = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN
  || DEFAULT_MAPBOX_TOKEN;
export const MAPBOX_DIRECTIONS_URL = 'https://api.mapbox.com/directions/v5/mapbox/driving';

// OSRM routing for the driver portal's route map. The default is OSRM's public
// DEMO server: rate-limited (~1 request/second), no SLA. Production should
// point REACT_APP_OSRM_ROUTE_URL at a self-hosted OSRM (same /route/v1 API).
export const OSRM_ROUTE_URL = (
  process.env.REACT_APP_OSRM_ROUTE_URL || 'https://router.project-osrm.org/route/v1/driving'
).replace(/\/$/, '');

// The office's WhatsApp: the one way the driver portal sends drivers to the
// office — drivers message it, they never call. Set
// REACT_APP_PH_OFFICE_WHATSAPP to change it.
export const PH_OFFICE_WHATSAPP = process.env.REACT_APP_PH_OFFICE_WHATSAPP || '+36707177656';

// The passenger terminal. It also hosts the page a driver records "on my way"
// and "arrived" on, one URL per booking. The API mints the very same link for
// its own messages (ph-core config PASSENGER_TERMINAL_URL and
// Helpers/PassengerTerminal.helper.ts), so the two must not drift: change
// REACT_APP_PASSENGER_TERMINAL_URL and ph-core's config together.
export const PASSENGER_TERMINAL_URL = (
  process.env.REACT_APP_PASSENGER_TERMINAL_URL || 'https://portal.pickuphungary.com'
).replace(/\/$/, '');

/**
 * The driver's event page for one booking, exactly as the API builds it:
 * `${PASSENGER_TERMINAL_URL}/driver/${operator_id}/${booking_reference}`.
 * '' when either half is missing — a half-built link is worse than none.
 */
export const driverEventUrl = (operatorId, bookingReference) => (
  operatorId && bookingReference
    ? `${PASSENGER_TERMINAL_URL}/driver/${operatorId}/${bookingReference}`
    : ''
);

/**
 * PICKUP HUNGARY'S OWN PARTNER RECORD — the house.
 *
 * A real row in Partners, not a sentinel: a PH-direct booking carries this id
 * in `partner_id` exactly as a Booking.com one carries theirs. The API knows
 * the same id as `PICKUP_HUNGARY_PARTNER_UUID` (ph-core `config.ts`), so the
 * two must not drift — change them together.
 *
 * It lives here rather than beside its first caller because it now has two:
 * the Home dashboard, which splits PH-direct bookings from partner ones, and
 * the order form, which defaults an EXPENSE to it. A cost we incur is ours
 * unless somebody says otherwise, and asking the office to pick the house
 * partner on every fuel receipt is how the field ends up wrong.
 */
export const PICKUP_HUNGARY_PARTNER_ID = 'c455727d-4bc1-4292-b423-da74120a3835';

// Who a portal login belongs to — the API's PortalUserKindEnum. One definition
// for the admin grant form and the portal's own principal handling.
export const PORTAL_USER_KINDS = {
  OPERATOR: 'operator',
  DRIVER: 'driver',
  // Pickup Hungary's own office staff: PH-wide and read-only, belonging to
  // no operator. Its board is /portal/dispatcher.
  DISPATCHER: 'dispatcher',
};

export default {
  MAPBOX_ACCESS_TOKEN,
  MAPBOX_DIRECTIONS_URL,
};
